<script>
  import GeneralButton from "../../components/button/GeneralButton.svelte";
</script>

<div style="margin: 5rem;">
  <h3>Buttons</h3>
  <h4>Small sized</h4>
  <div style="display: inline-flex; gap: 1rem; align-items: center; margin: 1rem;">
    <GeneralButton buttonType="primary" buttonSize="small">
      Button
    </GeneralButton>
    <GeneralButton buttonType="secondary" buttonSize="small">
      Button
    </GeneralButton>
    <GeneralButton buttonType="negative" buttonSize="small">
      Button
    </GeneralButton>
  </div>
  <div style="display: inline-flex; gap: 1rem; align-items: center; margin: 1rem;">
    <GeneralButton buttonType="primary" buttonSize="small" buttonDisabled={true}>
      Button
    </GeneralButton>
    <GeneralButton buttonType="secondary" buttonSize="small" buttonDisabled={true}>
      Button
    </GeneralButton>
    <GeneralButton buttonType="negative" buttonSize="small" buttonDisabled={true}>
      Button
    </GeneralButton>
  </div>

  <h4>Medium sized</h4>
  <div style="display: inline-flex; gap: 1rem; align-items: center; margin: 1rem;">
    <GeneralButton buttonType="primary" buttonSize="medium">
      Button
    </GeneralButton>
    <GeneralButton buttonType="secondary" buttonSize="medium">
      Button
    </GeneralButton>
    <GeneralButton buttonType="negative" buttonSize="medium">
      Button
    </GeneralButton>
  </div>
  <div style="display: inline-flex; gap: 1rem; align-items: center; margin: 1rem;">
    <GeneralButton buttonType="primary" buttonSize="medium" buttonDisabled={true}>
      Button
    </GeneralButton>
    <GeneralButton buttonType="secondary" buttonSize="medium" buttonDisabled={true}>
      Button
    </GeneralButton>
    <GeneralButton buttonType="negative" buttonSize="medium" buttonDisabled={true}>
      Button
    </GeneralButton>
  </div>

  <h4>Large sized</h4>
  <div style="display: inline-flex; gap: 1rem; align-items: center; margin: 1rem;">
    <GeneralButton buttonType="primary" buttonSize="large">
      Button
    </GeneralButton>
    <GeneralButton buttonType="secondary" buttonSize="large">
      Button
    </GeneralButton>
    <GeneralButton buttonType="negative" buttonSize="large">
      Button
    </GeneralButton>
  </div>
  <div style="display: inline-flex; gap: 1rem; align-items: center; margin: 1rem;">
    <GeneralButton buttonType="primary" buttonSize="large" buttonDisabled={true}>
      Button
    </GeneralButton>
    <GeneralButton buttonType="secondary" buttonSize="large" buttonDisabled={true}>
      Button
    </GeneralButton>
    <GeneralButton buttonType="negative" buttonSize="large" buttonDisabled={true}>
      Button
    </GeneralButton>
  </div>
</div>
